/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
// eslint-disable-next-line spire/fenced-imports
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import { COLORS } from "@tKgpco/theme/design";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return (
        <GridItem width={12}>
            <GridContainer
                style={{
                    padding: "9px 25px 9px 15px",
                    backgroundColor: `${COLORS.background.shade}`,
                    borderBottom: "1px solid #e2e3e6",
                }}
            >
                <GridItem width={[6, 6, 8, 8, 8]}>
                    <Typography className="card-list-heading" variant="h3">
                        {heading}
                    </Typography>
                </GridItem>
                {viewAllUrl && (
                    <GridItem width={[6, 6, 4, 4, 4]}>
                        <Link
                            href={viewAllUrl}
                            icon={{ iconProps: { src: ChevronRight } }}
                            typographyProps={{ size: 15 }}
                            css={css`
                                margin-left: auto;
                            `}
                            className="view-all-link"
                            data-test-selector="cardListHeadingViewAllLink"
                        >
                            {translate("View All")}
                            <VisuallyHidden>
                                {translate("View All")} {heading}
                            </VisuallyHidden>
                        </Link>
                    </GridItem>
                )}
            </GridContainer>
        </GridItem>
    );
};

export default CardListHeading;
